import { apiProxyRequest } from "Api/apiProxyRequest";

export const deleteSshKeysRequest = (keyId: string) =>
  apiProxyRequest(`/ssh_keys/${keyId}`, "DELETE");
